import { Modal, useModals } from 'almanac-ui/Modal'
import Styles from './FontsUploadModal.module.scss'
import { FontsUploadDropzone } from './FontsUploadDropzone'

export const FontsUploadModal = () => {
  const { closeModal } = useModals()

  return (
    <Modal.Root onPressOutside={closeModal} restoreFocus={false}>
      <Modal.Header title="Font Upload" headingLevel={4} />
      <div className={Styles.content}>
        <FontsUploadDropzone />
      </div>
    </Modal.Root>
  )
}
